import {Component, OnInit, TemplateRef} from '@angular/core';
import {AppComponent} from "../../../app.component";
import {NotifierService} from "angular-notifier";
import {FormControl, FormGroup} from "@angular/forms";
import {CabecalhoLayout} from "../../../shared/models/cabecalho-layout";
import {CampoCabecalhoLayout} from "../../../shared/models/campo-cabecalho-layout";
import {CabecalhoLayoutService} from "../../../core/services/cabecalho-layout.service";
import {isUndefined} from "util";
import {TipoLayout} from "../../../shared/models/tipo-layout";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";

@Component({
    selector: 'app-cabecalho-listar',
    templateUrl: './cabecalho-listar.component.html',
    styleUrls: ['./cabecalho-listar.component.css']
})
export class CabecalhoListarComponent implements OnInit {

    public breadCrumb;
    public cabecalhos_layout: Array<any> = [];
    public tipos_layout: Array<TipoLayout> = [];
    public cabecalho_layout: CabecalhoLayout = null;
    public campos_cabecalho_layout: Array<CampoCabecalhoLayout> = [];
    public form_campos: FormGroup;
    // public schemas: Array<Schema> = [];
    // public tabelas: Array<Tabela> = [];
    // public campos: Array<Campo> = [];
    public existe_padrao: boolean = true;
    public carregado: boolean = false;
    public modal_cabecalho_detail_ref: BsModalRef;
    public modal_cabecalho_form_ref: BsModalRef;
    public titulo: string = null;

    constructor(private appComponent: AppComponent,
                private cabecalhoLayoutService: CabecalhoLayoutService,
                private notifierService: NotifierService,
                private modalService: BsModalService,
                /*private tabelaService: TabelaService*/) {

    }

    ngOnInit() {
        this.breadCrumb = [
            {nome: "Configuração", caminho: "/configuracao"},
            {nome: "Cabeçalho", caminho: "/layout/cabecalho"}
        ];
        this.appComponent.setTitulo('Cabeçalho');
        this.appComponent.setBreadcrumb(this.breadCrumb);

        this.listar();

        this.form_campos = new FormGroup({
            codigo: new FormControl("", []),
            sigla: new FormControl("", []),
            descricao: new FormControl("", []),
            // schema: new FormControl("", []),
            // tabela: new FormControl("", []),
            // campo: new FormControl("", []),
            sql: new FormControl("", []),
            quantidade_caracteres: new FormControl(null, []),
            padrao: new FormControl("", []),
            ordem: new FormControl("", []),
        });
        // this.form_campos.get('schema').disable();
        // this.form_campos.get('tabela').disable();
        // this.form_campos.get('campo').disable();
        this.form_campos.get('sql').disable();
    }

    listar(): void {
        this.cabecalhos_layout = [];
        this.carregado = false;
        this.cabecalhoLayoutService.list().subscribe((data: Array<CabecalhoLayout>) => {
            this.carregado = true;
            if (data.length > 0) {
                data.forEach((cabecalho_layout: CabecalhoLayout) => {
                    if (cabecalho_layout.tipo_layout.sigla) {
                        let existe_tipo_layout: boolean = false;
                        if (this.tipos_layout.length > 0) {
                            this.tipos_layout.forEach((tipo_layout: TipoLayout) => {
                                if (tipo_layout.sigla == cabecalho_layout.tipo_layout.sigla) {
                                    existe_tipo_layout = true;
                                }
                            });
                        }
                        if (!existe_tipo_layout) {
                            this.tipos_layout.push(cabecalho_layout.tipo_layout);
                        }
                        if (isUndefined(this.cabecalhos_layout[cabecalho_layout.tipo_layout.sigla])) {
                            this.cabecalhos_layout[cabecalho_layout.tipo_layout.sigla] = [];
                        }
                        this.cabecalhos_layout[cabecalho_layout.tipo_layout.sigla].push(cabecalho_layout);
                    }
                });
            }
        }, () => {
            this.carregado = true;
            error => console.log(error);
        });
    }
    
    setCampos(cabecalho_layout: CabecalhoLayout, content_modal: TemplateRef<any>): void {
        this.cabecalho_layout = cabecalho_layout;
        this.titulo = cabecalho_layout.titulo;
        this.campos_cabecalho_layout = cabecalho_layout.campos_cabecalho_layout;
        this.modal_cabecalho_detail_ref = this.modalService.show(content_modal, {
            class: 'modal-lg',
            keyboard: false,
            focus: true
        });
    }

    copiar(cabecalho_layout: CabecalhoLayout): void {
        this.cabecalhoLayoutService.copy(cabecalho_layout).subscribe(() => {
            this.notifierService.notify('success', 'Cabeçalho copiado com sucesso');
            this.listar();
        }, () => {
            this.notifierService.notify('error', 'Ocorreu um erro ao copiar cabeçalho');
        });
    }

    subir(campo_cabecalho_layout: CampoCabecalhoLayout, i: number): void {
        let campos_cabecalho_layout: Array<CampoCabecalhoLayout> = [];
        if (this.campos_cabecalho_layout.length > 0) {
            this.campos_cabecalho_layout.forEach((campo_cabecalho_layout: CampoCabecalhoLayout, index) => {
                let tmp_campo_cabecalho_layout: CampoCabecalhoLayout = null;
                if (index == i) {
                    tmp_campo_cabecalho_layout = this.campos_cabecalho_layout[index - 1];
                    tmp_campo_cabecalho_layout.ordem = index - 1;
                } else if (index == (i - 1)) {
                    tmp_campo_cabecalho_layout = this.campos_cabecalho_layout[index + 1];
                    tmp_campo_cabecalho_layout.ordem = index + 1;
                } else {
                    tmp_campo_cabecalho_layout = campo_cabecalho_layout;
                }
                campos_cabecalho_layout.push(tmp_campo_cabecalho_layout);
            });
            this.campos_cabecalho_layout = campos_cabecalho_layout;
        }
    }

    descer(campo_cabecalho_layout: CampoCabecalhoLayout, i: number): void {
        let campos_cabecalho_layout: Array<CampoCabecalhoLayout> = [];
        if (this.campos_cabecalho_layout.length > 0) {
            this.campos_cabecalho_layout.forEach((campo_cabecalho_layout: CampoCabecalhoLayout, index) => {
                let tmp_campo_cabecalho_layout: CampoCabecalhoLayout = null;
                if (index == i) {
                    tmp_campo_cabecalho_layout = this.campos_cabecalho_layout[index + 1];
                    tmp_campo_cabecalho_layout.ordem = index + 1;
                } else if (index == (i + 1)) {
                    tmp_campo_cabecalho_layout = this.campos_cabecalho_layout[index - 1];
                    tmp_campo_cabecalho_layout.ordem = index - 1;
                } else {
                    tmp_campo_cabecalho_layout = campo_cabecalho_layout;
                }
                campos_cabecalho_layout.push(tmp_campo_cabecalho_layout);
            });
            this.campos_cabecalho_layout = campos_cabecalho_layout;
        }
    }

    atualizar(cabecalho_layout: CabecalhoLayout, campos_cabecalho_layout: Array<CampoCabecalhoLayout>): void {
        if(this.titulo) {
            cabecalho_layout.titulo = this.titulo;
            this.cabecalhoLayoutService.update(cabecalho_layout, campos_cabecalho_layout).subscribe(() => {
                this.notifierService.notify('success', 'Layout do cabeçalho atualizado com sucesso');
                this.modal_cabecalho_detail_ref.hide();
                this.campos_cabecalho_layout = [];
                this.cabecalho_layout = null;
                this.listar();
            }, () => {
                this.notifierService.notify('error', 'Ocorreu um erro ao atualizar o layout do cabeçalho');
            });
        }else{
            this.notifierService.notify('error', 'Informe o título');
        }
    }

    editar(campo_layout: CampoCabecalhoLayout, content_modal: TemplateRef<any>): void {
        this.form_campos.patchValue({
            codigo: campo_layout.codigo_campo_cabecalho_layout,
            sigla: campo_layout.sigla,
            descricao: campo_layout.descricao,
            // schema: "",
            // tabela: "",
            // campo: "",
            sql: campo_layout.sql,
            quantidade_caracteres: campo_layout.quantidade_caracteres,
            padrao: campo_layout.padrao,
            ordem: campo_layout.ordem,
        });
        this.existe_padrao = campo_layout.padrao ? true : false;
        this.form_campos.get('sigla').disable();
        if (this.existe_padrao) {
            this.form_campos.get('sql').disable();
            this.form_campos.get('padrao').enable();
        } else {
            this.form_campos.get('sql').enable();
            this.form_campos.get('padrao').disable();
        }
        this.modal_cabecalho_form_ref = this.modalService.show(content_modal, {
            class: 'modal-lg',
            keyboard: false,
            focus: true
        });
    }

    excluir(i: number): void {
        let campos_cabecalho_layout: Array<CampoCabecalhoLayout> = [];
        if (this.campos_cabecalho_layout.length > 0) {
            this.campos_cabecalho_layout.forEach((campo_cabecalho_layout: CampoCabecalhoLayout, index) => {
                if (index != i) {
                    campos_cabecalho_layout.push(campo_cabecalho_layout);
                }
            });
            this.campos_cabecalho_layout = campos_cabecalho_layout;
        }
    }

    definirCampoPadrao(): void {
        this.existe_padrao = !this.existe_padrao;
        if (this.existe_padrao) {
            // this.form_campos.get('schema').disable();
            // this.form_campos.get('tabela').disable();
            // this.form_campos.get('campo').disable();
            this.form_campos.get('sql').disable();
            this.form_campos.get('padrao').enable();
        } else {
            // this.form_campos.get('schema').enable();
            // this.form_campos.get('tabela').enable();
            // this.form_campos.get('campo').enable();
            this.form_campos.get('sql').enable();
            this.form_campos.get('padrao').disable();
        }
        this.form_campos.patchValue({
            padrao: "",
            // schema: "",
            // tabela: "",
            sql: "",
        });
    }

    public addCampo(content_modal: TemplateRef<any>): void {
        this.form_campos.get('sigla').enable();
        // $('#md-layout-cabecalho-detail').modal('hide');
        this.modal_cabecalho_form_ref = this.modalService.show(content_modal, {
            class: 'modal-lg',
            keyboard: false,
            focus: true
        });
        // this.listarSchemas();
        this.form_campos.patchValue({
            codigo: "",
            sigla: "",
            descricao: "",
            // schema: "",
            // tabela: "",
            // campo: "",
            sql: "",
            quantidade_caracteres: "",
            padrao: "",
            ordem: "",
        });
        // this.form_campos.get('schema').disable();
        // this.form_campos.get('tabela').disable();
        // this.form_campos.get('campo').disable();
        this.form_campos.get('sql').disable();
        this.form_campos.get('padrao').enable();
        this.existe_padrao = true;
    }

    // public listarSchemas(): void{
    //   this.tabelaService.listSchemas().subscribe((schemas: Array<Schema>) => {
    //     this.schemas = schemas;
    //   });
    // }
    //
    // public listarTabelas(schema): void{
    //   this.tabelaService.listTabelas(schema).subscribe((tabelas: Array<Tabela>) => {
    //     this.tabelas = tabelas;
    //   });
    // }
    //
    // public listarCampos(tabela, schema): void{
    //   this.tabelaService.listCampos(tabela, schema).subscribe((campos: Array<Campo>) => {
    //     this.campos = campos;
    //   });
    // }

    adicionarCampo(): void {
        let campo_cabecalho_layout: CampoCabecalhoLayout = new CampoCabecalhoLayout();
        let msg: Array<string> = [];
        campo_cabecalho_layout.quantidade_caracteres = this.form_campos.get('quantidade_caracteres').value;
        campo_cabecalho_layout.descricao = this.form_campos.get('descricao').value;
        campo_cabecalho_layout.sigla = this.form_campos.get('sigla').value;
        campo_cabecalho_layout.codigo_campo_cabecalho_layout = this.form_campos.get('codigo').value;
        if (!this.form_campos.get('quantidade_caracteres').value) {
            msg.push("Informe a quantidade de caracteres");
        } else if (this.existe_padrao && (!this.form_campos.get('padrao').value || this.form_campos.get('quantidade_caracteres').value != this.form_campos.get('padrao').value.length)) {
            msg.push('A quantidade de caracteres do padrão não está igual a quantidade de caracteres informada');
            //} else if(!this.existe_padrao && (!this.form_campos.get('schema').value || !this.form_campos.get('tabela').value || !this.form_campos.get('campo').value)){
        } else if (!this.existe_padrao && !this.form_campos.get('sql').value) {
            // msg.push("Informe os campos schema, tabela e campo");
            msg.push("Informe o campo sql");
        }
        if (msg.length > 0) {
            msg.forEach((message: string) => {
                this.notifierService.notify('error', message);
            });
        } else {
            if (this.form_campos.get('padrao').value) {
                campo_cabecalho_layout.padrao = this.form_campos.get('padrao').value;
                // campo_cabecalho_layout.schema = "";
                // campo_cabecalho_layout.tabela = "";
                // campo_cabecalho_layout.campo = "";
                campo_cabecalho_layout.sql = "";
            } else {
                campo_cabecalho_layout.padrao = "";
                // campo_cabecalho_layout.schema = this.form_campos.get('schema').value;
                // campo_cabecalho_layout.tabela = this.form_campos.get('tabela').value;
                // campo_cabecalho_layout.campo = this.form_campos.get('campo').value;
                campo_cabecalho_layout.sql = this.form_campos.get('sql').value;
            }
            if(campo_cabecalho_layout.codigo_campo_cabecalho_layout) {
                if(this.cabecalho_layout.campos_cabecalho_layout.length > 0){
                    this.cabecalho_layout.campos_cabecalho_layout.forEach((tmp_campo_cabecalho_layout: CampoCabecalhoLayout, i: number) => {
                        if(tmp_campo_cabecalho_layout.codigo_campo_cabecalho_layout == campo_cabecalho_layout.codigo_campo_cabecalho_layout){
                            this.cabecalho_layout.campos_cabecalho_layout[i] = campo_cabecalho_layout;
                        }
                    });
                }
                if(this.campos_cabecalho_layout.length > 0){
                    this.campos_cabecalho_layout.forEach((tmp_campo_cabecalho_layout: CampoCabecalhoLayout, i: number) => {
                        if(tmp_campo_cabecalho_layout.codigo_campo_cabecalho_layout == campo_cabecalho_layout.codigo_campo_cabecalho_layout){
                            this.campos_cabecalho_layout[i] = campo_cabecalho_layout;
                        }
                    });
                }
            }else{
                this.cabecalho_layout.campos_cabecalho_layout.push(campo_cabecalho_layout);
            }
            this.modal_cabecalho_form_ref.hide();
        }
    }

}
